import React from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Stack,
  IconButton,
} from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import MailIcon from "@mui/icons-material/Mail";
import InstagramIcon from "@mui/icons-material/Instagram";
import useLocales from "hooks/useLocales";

export default function LandingFooter() {
  const { translate } = useLocales();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "background.paper",
        py: 4,
        mt: 4,
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Container maxWidth="md">
        {/* Section Contact */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            {translate("Contact me")}
          </Typography>
          <Stack
            component="form"
            spacing={2}
            action="mailto:k2acim31@gmail.com"
            method="post"
            encType="text/plain"
            sx={{ maxWidth: 400, mx: "auto" }}
          >
            <TextField
              fullWidth
              label={translate("Name")}
              name="name"
              variant="outlined"
            />
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              variant="outlined"
            />
            <TextField
              fullWidth
              label={translate("Message")}
              name="message"
              multiline
              rows={4}
              variant="outlined"
            />
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button type="submit" variant="contained">
                {translate("send")}
              </Button>
              <Button type="reset" variant="outlined">
                {translate("reset")}
              </Button>
            </Stack>
          </Stack>
        </Box>

        {/* Section Réseaux Sociaux */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            {translate("Follow")}
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <IconButton
              href="https://github.com/ryodes"
              target="_blank"
              color="inherit"
            >
              <GitHubIcon />
            </IconButton>
            <IconButton
              href="https://twitter.com/ryodes31"
              target="_blank"
              color="inherit"
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              href="https://www.facebook.com/adel.kacimi.77"
              target="_blank"
              color="inherit"
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              href="https://www.instagram.com/adeluxonetheflux/"
              target="_blank"
              color="inherit"
            >
              <InstagramIcon />
            </IconButton>
            <IconButton href="mailto:k2acim31@gmail.com" color="inherit">
              <MailIcon />
            </IconButton>
          </Stack>
        </Box>

        {/* Section Copyright */}
        <Typography variant="body2" align="center" color="text.secondary">
          &copy; Ryodes | Design: Adel KACIMI
        </Typography>
      </Container>
    </Box>
  );
}
